import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ce265de2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ce265de2&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=ce265de2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce265de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce265de2')) {
      api.createRecord('ce265de2', component.options)
    } else {
      api.reload('ce265de2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ce265de2&scoped=true&", function () {
      api.rerender('ce265de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/court/recordCourt/index.vue"
export default component.exports